import React from "react"
import moment from "moment"
import {Link} from "react-router-dom"
import {useTranslation} from "react-i18next"

const ListItemOrderHistory = ({product, user, added_at, quantity, index}) => {
  const {t} = useTranslation()
  return (
    <div className="sh-list-item">
      <div className="content">
        <Link to={`/product/${product.id}`}>
          <div className="box-name">
            <div className="article-position primary">
              {t("orders.position", {position: index + 1, index: index + 1})}
            </div>
            <div className="article-description">
              <div className="primary">{product.name}</div>
              <div className="secondary simplified">
                <span>
                  {t("orders.addedByAt", {
                    user: user.email,
                    date: moment(added_at).format("DD.MM.YYYY"),
                    at: moment(added_at).format("DD.MM.YYYY")
                  })}
                </span>
              </div>
            </div>
            <div className="primary">
              {quantity} {product.unit}
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default ListItemOrderHistory



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemOrderHistoryDetails.js